import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import { RESET_PASSWORD } from "../../mutation/ResetPassword";
import { useMutation } from "@apollo/react-hooks";

const ResetPassword = () => {
  const history = useHistory();
  const [ResetPasswordMutation] = useMutation(RESET_PASSWORD);

  return (
    <div className="login-cover" style={{ width: 420 }}>
      <div className="login-box reset-password">
        {/* <div className="left-arrow">
                  <Link to="/login">
                    <img src={arrow} alt="arrow" />
                  </Link>
                </div> */}
        <h1
          style={{ fontSize: "24px", fontWeight: "600", marginBottom: "12px" }}
        >
          Reset your password
        </h1>
        <p style={{ marginTop: 12, marginBottom: 40 }}>
          Type in your email address below and we'll send you an email to create
          a new password.
        </p>

        <Formik
          initialValues={{ email: "" }}
          validationSchema={Yup.object({
            email: Yup.string()
              .email("Invalid Email Address")
              .required("Please enter your email"),
          })}
          onSubmit={(values, { setFieldError, setSubmitting }) => {
            ResetPasswordMutation({
              variables: {
                email: values.email,
              },
            })
              .then((response) => {
                localStorage.setItem(
                  "resend_forgot_password_email",
                  values.email
                );
                setSubmitting(false);
                history.push("/reset-password/2");
              })
              .catch((e) => {
                const errors = e.graphQLErrors;
                if (errors[0] && errors[0].message) {
                  setFieldError("email", errors[0].message);
                }

                setSubmitting(false);
              });
          }}
        >
          {({ isSubmitting }) => (
            <Form className="login-form">
              <div className="form-group">
                <label>Email Address</label>
                <Field
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email here"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="error-message"
                />
              </div>

              <div className="form-submit">
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  Send me the link
                </button>
              </div>
            </Form>
          )}
        </Formik>

        {/* <form className="login-form">
                    <div className="form-group">
                        <label>Email</label>
                        <input type="text" className="form-control" />
                    </div>                                       
                    <div className="form-submit">
                        <input type="submit" className="submit-btn" value="Next" />
                    </div>
                </form> */}
      </div>
    </div>
  );
};

export default ResetPassword;
